<template>
  <v-card-actions class="mb-3">
    <v-spacer />
    <v-btn
      color="#6A6E7B"
      outlined
      @click="back()"
    >
      Cancelar
    </v-btn>
    <v-btn
      v-if="isNext"
      color="primary"
      class="ml-2"
      @click="nextStep($event)"
    >
      Próximo
    </v-btn>
    <notification-save-button v-else />
  </v-card-actions>
</template>

<script>
import RouterMixin from '@/app/arch/mixins/RouterMixin';
import StorageMixin from '@/app/arch/mixins/StorageMixin';
import NotificationSaveButton from 'Modules/contacard/communication/notifications/components/buttons/NotificationSaveButton.vue';

export default {
  name: 'NotificationActionForm',
  components: { NotificationSaveButton },
  mixins: [RouterMixin, StorageMixin],
  props: {
    backRoute: {
      type: String,
      default: 'contacard.submodules.list',
    },
    next: {
      type: Boolean,
    },
    edit: {
      type: Boolean,
    },
  },
  computed: {
    getBackRoute() {
      return this.backRoute;
    },
    getListQueryParams() {
      return this.getLocalItem('listQuery');
    },
    isNext() {
      return this.next;
    },
    isEdit() {
      return this.edit;
    },
  },
  methods: {
    back() {
      this.navigateTo(
        this.getBackRoute,
        this.getListQueryParams,
      );
    },
    nextStep(ev) {
      this.$emit('nextStep', ev);
    },
  },
};
</script>
